import { ConsentRow, NamirasoftAccountServer, TokenManager } from "namirasoft-account";
import { CacheService, EnvService, IStorageLocal } from "namirasoft-core";

export class ConsentCacheService
{
    static get(manager: TokenManager, product_id: string, onError: (error: Error | string, timout?: number) => void)
    {
        let user_id = manager.getUserData(user => user.id, "");
        let key = `ns-account-consent-user-${user_id}-product-${product_id}`;
        return new CacheService<ConsentRow | null>(key, new IStorageLocal(), 7 * 24 * 60, async () => "1.0.0", async () =>
        {
            let REACT_APP_BASE_URL_ACCOUNT = new EnvService("REACT_APP_BASE_URL_ACCOUNT", true).getString();
            let server = new NamirasoftAccountServer(REACT_APP_BASE_URL_ACCOUNT, manager, onError);
            try
            {
                debugger;
                let ans = await server.consent.GetByProduct(product_id);
                return ans;
            } catch (error)
            {
                debugger;
                return null;
            }
        });
    }
}